export enum RevenueSourceType {
  FOOD = 'FOOD',
  DRINKS = 'DRINKS',
  TAKE_AWAY = 'TAKE_AWAY',
  CATERING = 'CATERING',
  HOTEL = 'HOTEL',
  OTHER = 'OTHER',
}

export const getRevenueSourceTypeDisplayName = (type: RevenueSourceType): string => {
  switch (type) {
    case RevenueSourceType.FOOD:
      return "Food";
    case RevenueSourceType.DRINKS:
      return "Drinks";
    case RevenueSourceType.TAKE_AWAY:
      return "Take Away";
    case RevenueSourceType.CATERING:
      return "Catering";
    case RevenueSourceType.HOTEL:
      return "Hotel";
    case RevenueSourceType.OTHER:
      return "Other";
    default:
      return type;
  }
};

export const getAvailableRevenueSourceTypes = (): RevenueSourceType[] => {
  return Object.values(RevenueSourceType);
};
